import React, { useState } from "react";
import "./style.scss";
import Card from "../../../reusableComponents/Card";
import { useTable, usePagination } from "react-table";

import CalenderIcon from "../../../assets/icons/calender.svg";
import DropdownIcon from "../../../assets/icons/dropdown-arrow-gray.svg";
import Profile from "../../../assets/icons/profile.svg";
import Download from "../../../assets/icons/download.svg";
import Tooltip from "@mui/material/Tooltip";

import CaretLeftIcon from "../../../assets/icons/caret-left.svg";
import CaretRightIcon from "../../../assets/icons/caret-right.svg";
import moment from "moment";
import { convertTimestamp, FormatUSD } from "../../../utils/string";

function TradeHistory({ tableData, isTradelocker }) {
  console.log(tableData, "tableDatatableData");
  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      marginTop: "4px",
      height: 48,
      borderRadius: 8,
      border: "none",
      boxShadow: "none",
      paddingRight: "20px",
      fontFamily: "DM Sans , sans-serif",
      fontSize: "14px",
      fontWeight: 700,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
    }),
  };

  return (
    <Card className="transactionhistory">
      <div className="transactionhistory_header">
        <h3>Trade History</h3>

        <div className="select_wrapper">
          {/* <img className="select_icon" src={CalenderIcon} alt="calender icon" /> */}
        </div>
      </div>
      <div className="table_wrapper">
        <Table tableData={tableData || []} isTradelocker={isTradelocker} />
      </div>
    </Card>
  );
}

export default TradeHistory;

const Table = ({ tableData, isTradelocker }) => {
  const data = tableData;

  console.log("isTradelocker", isTradelocker);

  const columnsUnified = React.useMemo(
    () => [
      {
        Header: "Login Id",
        accessor: "login",
      },
      {
        Header: () => (
          <div className="column_header">
            Action
            <img src={DropdownIcon} alt="arrow-down" />
          </div>
        ),
        accessor: "action",
        Cell: ({ value }) => (
          <div className="column_one_wrapper">
            <div className={value === "Buy" ? "profit" : "loss"}>{value}</div>
          </div>
        ),
      },
      {
        Header: () => (
          <div className="column_header">
            Position <img src={DropdownIcon} alt="arrow-down" />
          </div>
        ),
        accessor: "position",
      },
      {
        Header: () => (
          <Tooltip title="Total volume" placement="top" arrow>
            <span>Vol</span>
          </Tooltip>
        ),
        accessor: "volumeSumBuy",
        Cell: ({ row }) => {
          const buyVol = row.original.volumeSumBuy ?? 0;
          const sellVol = row.original.volumeSumSell ?? 0;
          // Use the non-zero value or take absolute of whichever is present
          const vol = buyVol !== 0 ? Math.abs(buyVol) : Math.abs(sellVol);
          return <div>{vol || "NA"}</div>;
        },
      },
      {
        Header: "Symbol",
        accessor: "symbol",
      },
      {
        Header: () => (
          <div className="column_header">
            Open Date <img src={DropdownIcon} alt="arrow-down" />
          </div>
        ),
        accessor: "dateOpen",
        Cell: ({ value }) => {
          const timestamp = parseInt(value, 10);
          return (
            <div>
              {moment.utc(timestamp).isValid()
                ? moment.utc(timestamp).format("DD-MM-YYYY HH:mm:ss")
                : "-"}
            </div>
          );
        },
      },
      {
        Header: () => (
          <div className="column_header">
            Close Date <img src={DropdownIcon} alt="arrow-down" />
          </div>
        ),
        accessor: "dateClose",
        Cell: ({ value }) => (
          <div>
            {value && moment(value).isValid()
              ? moment(value).format("DD-MM-YYYY HH:mm:ss")
              : "-"}
          </div>
        ),
      },
      {
        Header: () => (
          <div className="column_header">
            Profit <img src={DropdownIcon} alt="arrow-down" />
          </div>
        ),
        accessor: "profitSum",
        Cell: ({ value }) => (
          <div className={value < 0 ? "loss" : value > 0 ? "profit" : ""}>
            {FormatUSD(value ?? "-")}
          </div>
        ),
        className: "align-profit",
      },
      {
        Header: () => (
          <div className="column_header">
            Commission <img src={DropdownIcon} alt="arrow-down" />
          </div>
        ),
        accessor: "commissionSum",
        Cell: ({ value }) => (
          <div className={value == 0 ? "" : "loss"}>
            {value != 0 && "-"}{FormatUSD(value || "-")}
          </div>
        ),
        className: "align-commission",
      },
      {
        Header: () => (
          <div className="column_header">
            Swap <img src={DropdownIcon} alt="arrow-down" />
          </div>
        ),
        accessor: "swapSum",
        Cell: ({ value }) => (
          <div className={value > 0 ? "profit" : value < 0 ? "loss" : ""}>
            {FormatUSD(value || "-")}
          </div>
        ),
        className: "align-swap",
      },
      {
        Header: () => (
          <Tooltip title="Average price when bought" placement="top" arrow>
            <span>Avg Price Buy</span>
          </Tooltip>
        ),
        accessor: "priceAvgBuy",
        Cell: ({ value }) => <div>{FormatUSD(value ?? "-")}</div>,
      },
      {
        Header: () => (
          <Tooltip title="Average price when bought" placement="top" arrow>
            <span>Avg Price Sell</span>
          </Tooltip>
        ),
        accessor: "priceAvgSell",
        Cell: ({ value }) => <div>{FormatUSD(value ?? "-")}</div>,
      },

      {
        Header: "Stop Loss",
        accessor: "stopLoss",
        Cell: ({ value }) => <div>{FormatUSD(value ?? "-")}</div>,
      },
      {
        Header: "Take Profit",
        accessor: "takeProfit",
        Cell: ({ value }) => <div>{FormatUSD(value ?? "-")}</div>,
      },
    ],
    [isTradelocker],
  );

  const columnsTradelocker = React.useMemo(
    () => [
      {
        Header: "Instrument",
        accessor: "instrument",
      },
      {
        Header: "Open Date/Time",
        accessor: "openDateTime",
        Cell: ({ value }) => (
          <div>
            {value && moment.utc(value).isValid()
              ? moment.utc(value).format("DD-MM-YY")
              : "-"}
          </div>
        ),
      },
      {
        Header: "Order Type",
        accessor: "orderType",
      },
      {
        Header: "Position Side",
        accessor: "positionSide",
        Cell: ({ value }) => (
          <div className={value === "Buy" ? "profit" : "loss"}>{value}</div>
        ),
      },
      {
        Header: "Close Amount",
        accessor: "closeAmount",
        Cell: ({ value }) => <div>{FormatUSD(value ?? "-")}</div>,
      },
      {
        Header: "Average Open Price",
        accessor: "averageOpenPrice",
        Cell: ({ value }) => <div>{FormatUSD(value ?? "-")}</div>,
      },
      {
        Header: "Close Price",
        accessor: "closePrice",
        Cell: ({ value }) => <div>{FormatUSD(value ?? "-")}</div>,
      },
      {
        Header: "Close Date/Time",
        accessor: "closeDateTime",
        Cell: ({ value }) => (
          <div>
            {value && moment.utc(value).isValid()
              ? moment.utc(value).format("DD-MM-YY")
              : "-"}
          </div>
        ),
      },
      {
        Header: "Open Amount",
        accessor: "openAmount",
        Cell: ({ value }) => <div>{FormatUSD(value ?? "-")}</div>,
      },
      {
        Header: "Commission",
        accessor: "commission",
        Cell: ({ value }) => (
          <div className={value == 0 ? "" : "loss"}>
            {value != 0 && "-"}{FormatUSD(value || "-")}
          </div>
        ),
        className: "align-commission",
      },
      {
        Header: "Swap",
        accessor: "swap",
        className: "align-swap",
        Cell: ({ value }) => (
          <div className={value > 0 ? "profit" : value < 0 ? "loss" : ""}>
            {FormatUSD(value ?? "-")}
          </div>
        ),
      },
      {
        Header: "Profit",
        accessor: "profit",
        Cell: ({ value }) => (
          <div className={value > 0 ? "profit" : value < 0 ? "loss" : ""}>
            {FormatUSD(value ?? "-")}
          </div>
        ),
        className: "align-profit",
      },
      {
        Header: "Net Profit",
        accessor: "netProfit",
        Cell: ({ value }) => (
          <div className={value > 0 ? "profit" : value < 0 ? "loss" : ""}>
            {FormatUSD(value ?? "-")}
          </div>
        ),
      },
    ],
    [],
  );

  const columns =
    isTradelocker === "tradelocker" ? columnsTradelocker : columnsUnified;

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    pageCount,
    pageOptions,
    state,
    pageIndex,
    rows,
    prepareRow,
  } = useTable({ columns, data }, usePagination);

  const [currentPage, setCurrentPage] = useState(1);
  const pageButtons = [];

  for (let i = 1; i <= pageCount; i++) {
    pageButtons.push(
      <button
        key={i}
        className={`${i === currentPage ? "button-active" : "button-inactive"}`}
        onClick={() => {
          gotoPage(i - 1);
          setCurrentPage(i);
        }}
      >
        {i < 10 ? `0${i}` : i}
      </button>,
    );
  }

  const renderPageButtons = () => {
    const buttons = [];
    const maxVisible = 2; // number of neighbors around current page

    if (pageCount <= 7) {
      // Small number of pages → show all
      for (let i = 1; i <= pageCount; i++) {
        buttons.push(
          <button
            key={i}
            className={i === currentPage ? "button-active" : "button-inactive"}
            onClick={() => {
              gotoPage(i - 1);
              setCurrentPage(i);
            }}
          >
            {i < 10 ? `0${i}` : i}
          </button>,
        );
      }
    } else {
      // Always show first page
      buttons.push(
        <button
          key={1}
          className={currentPage === 1 ? "button-active" : "button-inactive"}
          onClick={() => {
            gotoPage(0);
            setCurrentPage(1);
          }}
        >
          01
        </button>,
      );

      // Left dots
      if (currentPage > maxVisible + 2) {
        buttons.push(<span key="left-dots">…</span>);
      }

      // Middle pages
      const start = Math.max(2, currentPage - maxVisible);
      const end = Math.min(pageCount - 1, currentPage + maxVisible);

      for (let i = start; i <= end; i++) {
        buttons.push(
          <button
            key={i}
            className={i === currentPage ? "button-active" : "button-inactive"}
            onClick={() => {
              gotoPage(i - 1);
              setCurrentPage(i);
            }}
          >
            {i < 10 ? `0${i}` : i}
          </button>,
        );
      }

      // Right dots
      if (currentPage < pageCount - maxVisible - 1) {
        buttons.push(<span key="right-dots">…</span>);
      }

      // Last page
      buttons.push(
        <button
          key={pageCount}
          className={
            currentPage === pageCount ? "button-active" : "button-inactive"
          }
          onClick={() => {
            gotoPage(pageCount - 1);
            setCurrentPage(pageCount);
          }}
        >
          {pageCount < 10 ? `0${pageCount}` : pageCount}
        </button>,
      );
    }

    return buttons;
  };

  return (
    <>
      <table {...getTableProps()} className="table">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  className={column.className || ""}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <td
                    {...cell.getCellProps()}
                    className={cell.column.className || ""}
                  >
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="pagination">
        <img src={CaretLeftIcon} alt="" />
        <button
          onClick={() => {
            previousPage();
            setCurrentPage(currentPage - 1);
          }}
          disabled={!canPreviousPage}
        >
          Previous
        </button>

        {renderPageButtons()}

        <button
          onClick={() => {
            nextPage();
            setCurrentPage(currentPage + 1);
          }}
          disabled={!canNextPage}
        >
          Next
        </button>
        <img src={CaretRightIcon} alt="" />
      </div>
    </>
  );
};
